import * as React from 'react';

import IconCollectionsStarFilled from './IconCollectionsStarFilled';

export const collectionsStarFilled = () => <IconCollectionsStarFilled />;

export default {
    title: 'Icons|Collections|StarFilled',
    component: IconCollectionsStarFilled,
    parameters: {
        notes:
            "`import IconCollectionsStarFilled from 'box-ui-elements/es/icons/collection/IconCollectionsStarFilled';`",
    },
};
